/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.outerwrap[_ngcontent-%COMP%]{height:100%}.actionbar[_ngcontent-%COMP%]{margin-top:15px}.mat-form-field[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/textnote/textnote.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js